import React, { useContext, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faMusic, faMapMarkedAlt, faQrcode, faKey, faPuzzlePiece, faRadio, faPlay } from '@fortawesome/free-solid-svg-icons';
import { WalkDataContext } from './hooks/walkDataContext';

function NavigationTabs({ activeTab, onTabChange }) {
  const { contentState, tracks, storyFeatures } = useContext(WalkDataContext);

  const icons = {
    'info': faHome,
    'track-details': faHome,
    'playlist': faMusic,
    'map': faMapMarkedAlt,
    'qr': faQrcode,
    'password': faKey,
    'quest' : faPuzzlePiece,
    'radio' : faRadio,
    'lab' : faPlay
  };

  const ariaLabels = {
    'info': 'Information',
    'track-details': 'Track Details',
    'playlist': 'Playlist',
    'map': 'Map',
    'qr': 'QR Code',
    'password': 'Password',
    'quest': 'Quest',
    'radio': 'Radio',
    'lab': 'Audio Lab'
  };

  const getIconForTab = (tab) => {
    return icons[tab];
  };

  const getAriaLabelForTab = (tab) => {
    let label = ariaLabels[tab] || tab;

    if (tab === 'lab' && countHighlightedActiveTracks > 0) {
      label += `, ${countHighlightedActiveTracks} new track${countHighlightedActiveTracks > 1 ? 's' : ''}`;
    }

    if (tab === 'quest' && countHighlightedActivePuzzles > 0) {
      label += `, ${countHighlightedActivePuzzles} active puzzle${countHighlightedActivePuzzles > 1 ? 's' : ''}`;
    }

    return label;
  };

  //let navigationTabs = ['info', 'playlist', 'map', 'qr'];
  const navigationTabs = storyFeatures.filter(feature => 
    feature in icons
  );

  const countHighlightedActiveTracks = useMemo(() => {
    return contentState.filter(item => 
      item.type === 'track' && 
      item.state === 'active' && 
      item.highlight === true &&
      !(tracks.find(track => track.slug === item.slug)?.metadata?.trackMeta_radio?.[1])
    ).length;
  }, [contentState, tracks]);

  const countHighlightedActivePuzzles = useMemo(() => {
    return contentState.filter(item => 
      item.type === 'puzzle' && 
      item.state === 'active'
    ).length;
  }, [contentState]);


  return (
    <nav className="navbar fixed-bottom navbar-light bg-light" aria-label="Tab navigation">
      <div className="container-fluid justify-content-around">
        {navigationTabs.map(tab => (
          
          <div key={tab} className={`nav-item nav-item-${tab}`} style={{ position: 'relative' }}>
            <button
              className={`btn btn-link ${activeTab === tab ? 'active' : ''}`}
              onClick={() => onTabChange(tab)}
              aria-label={getAriaLabelForTab(tab)}
              aria-current={activeTab === tab ? 'page' : undefined}
            >
              <FontAwesomeIcon icon={getIconForTab(tab)} aria-hidden="true" />
              {tab === 'lab' && countHighlightedActiveTracks > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: 'red',
                  color: 'white',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '12px'
                }}
                className="highlight-active-tracks"
                aria-hidden="true"
                >
                  <span className="highlight-active-tracks-count">
                    {countHighlightedActiveTracks}
                  </span>
                </span>
              )}
              {tab === 'quest' && countHighlightedActivePuzzles > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  background: 'green',
                  color: 'white',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '12px'
                }}
                className="highlight-active-puzzles"
                aria-hidden="true">
                  <span className="highlight-active-puzzles-count">
                    {countHighlightedActivePuzzles}
                  </span>
                </span>
              )}
            </button>
          </div>
        ))}
      </div>
    </nav>
  );
}

export default NavigationTabs;